var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-result"},[_c('span',{class:{
      won: _vm.status === 1,
      draw: _vm.status === 0,
      lost: _vm.status === 2
    }},[_vm._v(_vm._s(_vm.resultText))])])}
var staticRenderFns = []

export { render, staticRenderFns }